import Utils from '@s/utils'
import router from '@/router'

const state = {
    messages: {
        success: [],
        error:[],
        info: [],
        warning: []
    }
}

const getters = {
    messages: state => {
        return state.messages;
    },

}

const mutations = {
    addMessage (state,payload) {
        let messages = Utils.formatMessages(payload.message)
        state.messages[payload.type] = state.messages[payload.type].concat(messages);
    },

    addSuccess (state,payload) {
        let messages = Utils.formatMessages(payload)
        state.messages.success = state.messages.success.concat(messages);
    },

    addError (state,payload) {
        let messages = Utils.formatMessages(payload)
        state.messages.error = state.messages.error.concat(messages);
    },

    addInfo (state,payload) {
        let messages = Utils.formatMessages(payload)
        state.messages.info = state.messages.info.concat(messages);
    },

    addWarning (state,payload) {
        let messages = Utils.formatMessages(payload)
        state.messages.warning = state.messages.warning.concat(messages);
    },

    clearMessages (state, payload){
        state.messages = {
            success: [],
            error:[],
            info: [],
            warning: []
        }
    },
    checkMessageCount(state,payload){

        var count = router.routeCount;

        for(var i = 0; i < state.messages[payload].length; i++){
            if(state.messages[payload][i].count == count - 2){
                state.messages[payload].splice(i,1);
            }
        }
    }
}

const actions = {
    checkCountsForAutoDisappear (context){
        context.commit('checkMessageCount','success');
        context.commit('checkMessageCount','error');
        context.commit('checkMessageCount','info');
        context.commit('checkMessageCount','warning');
    },

}


const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/stores/modules/messages/store.js